import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ShopService } from '../../../configuration/services/shop.service';
import { DistributorService } from '../../../distributors/services/distributor.service';
import { ExpensesService } from '../../services/expenses.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-view-expenses',
  templateUrl: './view-expenses.component.html',
  styleUrls: ['./view-expenses.component.css'],
  providers: [DistributorService,ShopService,ExpensesService]
})
export class ViewExpensesComponent implements OnInit {
    id: number = undefined;
    productId: number = undefined;
    private sub: any;
    expense: any = {};
    shops: any = [];
    distributors:any = [];
    distributor: any = {};
    showDistributorsForm:boolean = false;
    config: any = {'sourceField': ['name']};


  constructor(private route: ActivatedRoute, private router: Router,public toastr: ToastsManager, vcr: ViewContainerRef, private shopService:ShopService, private distributorService:DistributorService, private expensesService:ExpensesService) { 
    this.getShops().then(()=>{
        this.sub = this.route.params.subscribe(params => {
            if (params['id'] !== undefined){
                this.id = params['id'];
                this.getExpense();
            }
        });
        this.getDistributors();
        this.toastr.setRootViewContainerRef(vcr);
    });
  }

  ngOnInit() {
  }

  distributorSelected(event){
    this.expense.distributor_id = event.id
  }

  getShops(){
    return new Promise((resolve, reject) => {
        this.shopService.query({})
        .subscribe((shops) => {
            this.shops = shops;
            resolve();
        });
    });
  }
  getDistributors(){
      this.distributorService.query({}).subscribe((distributors) => {
        this.distributors = distributors; 
      });
  }
  saveDistributor(){
    this.distributorService.create(this.distributor)
    .subscribe((distributor) => {
        this.getDistributors();
        this.distributor = {};
        this.showDistributorsForm = false;
    });
  }

  getExpense(){
    this.expensesService.get(this.id).subscribe((expense) => {
        this.expense = expense;
        this.expense.shop_id = expense.shop.id;
        this.expense.invoice_date = moment(expense.invoice_date).format("YYYY-MM-DD");
        this.expense.method_of_payment = expense.method_of_payment ==  "Efectivo"? 1:expense.method_of_payment ==  "Tarjeta"? 2:expense.method_of_payment ==  "Transferencia"? 3:null
    });
  }

  calculateAmount(){
    if (this.expense.net_amount != null && this.expense.net_amount != "" && this.expense.tax != null && this.expense.tax != ""){
      this.expense.amount = this.roundValue(this.expense.net_amount * ((this.expense.tax/100)+1));
    }else{
      this.expense.amount = 0
    }
    if (this.expense.net_amount2 != null && this.expense.net_amount2 != "" && this.expense.tax2 != null && this.expense.tax2 != ""){
      this.expense.amount += this.roundValue(this.expense.net_amount2 * ((this.expense.tax2/100)+1));
    }
  }

  roundValue(value){
    return Math.round(value * 100) / 100;
  }

  saveExpense(){
    if (!this.expense.id){
      this.expensesService.checkInvoice({invoice_number:this.expense.invoice_number, distributor_id:this.expense.distributor_id, invoice_date:this.expense.invoice_date}).subscribe((alreadyExist) =>{
        if(!alreadyExist.result){
          this.expensesService.create(this.returnProperties(this.expense)).subscribe((expense) =>{
            this.expense = expense;
            this.router.navigate(["/tpv"]); 
          });
        }else{
          this.toastr.warning('', 'Gasto Duplicado', {dismiss: "controlled",showCloseButton:true});
        }
      })
    }else{
        this.expensesService.update(this.returnProperties(this.expense)).subscribe((expense) =>{
            this.expense = expense;
            this.router.navigate(["/expenses/list"]); 
        });
    }
  }

  returnProperties(expense){
    var properties = {
        invoice_number: expense.invoice_number,
        invoice_date: expense.invoice_date,
        concept: expense.concept,
        net_amount: expense.net_amount,
        tax: expense.tax,
        net_amount2: expense.net_amount2,
        tax2: expense.tax2,
        amount: expense.amount,
        type: expense.type,
        method_of_payment: expense.method_of_payment ==  1? "Efectivo":expense.method_of_payment ==  2? "Tarjeta":expense.method_of_payment ==  3? "Transferencia":null,
        shop_id: expense.shop_id,
        distributor_id: expense.distributor_id
    }
    if (expense.id){
      properties['id'] = expense.id;
    }
    console.log(properties)
    return properties;
  }

  
}


// WEBPACK FOOTER //
// ./src/app/expenses/components/view-expenses/view-expenses.component.ts